import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user-manager",
  "use": "icon-user-manager-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-user-manager\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 541.696a206.805333 206.805333 0 0 1-206.762667-206.848A206.805333 206.805333 0 1 1 512 541.696z m-283.349333 118.954667c128.128-39.466667 222.592-59.136 283.349333-59.136 60.757333 0 155.221333 19.669333 283.349333 59.136 34.261333 10.581333 57.984 45.568 57.984 85.546666V896H170.666667v-149.76c0-39.936 23.722667-74.965333 57.984-85.504v-0.085333z\" p-id=\"2949\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/user-manager.svg
// module id = howH
// module chunks = 115